<template>
<div class="column" v-html="item.content"></div>
</template>

<script>
export default {
    name    :   'RowColumn',
    props   :   ['item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/RowColumn.vue